import React from "react"

import { Container, ButtonLoader } from "./SecondaryButton.styled"

type Props = {
  children: React.ReactNode
  loading?: boolean
  disabled?: boolean
  handleClick?: React.MouseEventHandler
  type?: "button"
  title?: string
  /**
   * @deprecated Use ProtectedButton wrapper instead of overrideDisabled
   * This prop is kept for backward compatibility but will be removed in future versions
   */
  overrideDisabled?: boolean
}

const SecondaryButton = ({
  children,
  handleClick,
  loading = false,
  disabled = false,
  overrideDisabled,
  type,
  title,
  ...props
}: Props) => {
  const isDisabled = overrideDisabled !== undefined
    ? !overrideDisabled && disabled
    : disabled

  return (
    <Container
      disabled={isDisabled}
      type={type}
      $loading={loading}
      onClick={handleClick}
      title={title || ""}
      {...props}
    >
      {loading && <ButtonLoader />}
      <span>{children}</span>
    </Container>
  )
}

export default SecondaryButton
